<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: flex-start;">
            <el-date-picker
              v-model="months"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              value-format="yyyy-MM"
              @change="search">
            </el-date-picker>
          </div>
          <div style="display: flex;justify-content: flex-end;">
            <el-button type="primary" size="small" @click="handleExcelExport"
                       icon="el-icon-download" class="ml20">导出
            </el-button>
          </div>
        </div>
        <div class="main mt20">
          <el-table :data="table.data" height="600px" border :header-cell-style="{background:'#fafafa',color:'#000000'}"
                    v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="销售" align="center"
                             prop="sale"></el-table-column>
            <el-table-column show-overflow-tooltip label="公司业绩" align="center"
                             prop="saleCompanyTotal"></el-table-column>
            <el-table-column show-overflow-tooltip label="公司单数" align="center"
                             prop="companyBillTotal"></el-table-column>
            <el-table-column show-overflow-tooltip label="合作方业绩" align="center"
                             prop="saleCooperateTotal"></el-table-column>
            <el-table-column show-overflow-tooltip label="签约月数" align="center"
                             prop="monthTotal"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {getMonthList} from "@/api/performanceRecord";

export default {
  data() {
    return {
      table: {
        query: {
          actualRentDate: '',
          saleId: ''
        },
      },
      months: [],
      tableLoading: false,
      isSale: false
    }
  },
  mounted() {
    this.search()
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.isSale = this.userInfo.roleIds.indexOf('3') != -1 || this.userInfo.roleIds.indexOf('6') != -1
  },
  methods: {
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (this.isSale) {
        this.table.query.saleId = this.userInfo.id
      }
      if (this.months && this.months.length > 0) {
        this.table.query.startDate = this.months[0]
        this.table.query.endDate = this.months[1]
      } else {
        this.table.query.startDate = ''
        this.table.query.endDate = ''
      }
      getMonthList(this.table.query).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    handleExcelExport() {
      if (this.isSale) {
        window.open(`/hrApi/performanceRecord/list/export?statisticType=1&startDate=${this.table.query.startDate}&endDate=${this.table.query.endDate}&saleId=${this.userInfo.id}&token=${localStorage.getItem('token')}`);
      } else {
        window.open(`/hrApi/performanceRecord/list/export?statisticType=1&startDate=${this.table.query.startDate}&endDate=${this.table.query.endDate}&token=${localStorage.getItem('token')}`);
      }
      this.$message.success("导出成功！");
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PerformanceMonth.vue